import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Message.svg'

export const IconMessage = IconSVG as IconComponent
